/* custom-menu-scroll.js
   Intercepts "About Us" and "Contact" menu clicks on the homepage
   and smooth-scrolls to the corresponding sections instead of navigating away.
*/
(function () {
  'use strict';

  // Define scroll targets: match by link text OR by href containing these paths
  var scrollMap = [
    {
      textMatch: 'about us',
      hrefMatch: '/pages/about',
      selector: '[class*="custom-who-we-are"], .custom-who-we-are'
    },
    {
      textMatch: 'contact',
      hrefMatch: '/pages/contact',
      selector: '.custom-contact, .ccs-section'
    },
    {
      textMatch: 'policies and privacy',
      hrefMatch: '/pages/policies',
      redirect: '/pages/policies-and-privacy'
    }
  ];

  function isHomePage() {
    var path = window.location.pathname.replace(/\/+$/, '');
    return path === '' || path === '/';
  }

  function getMatchedTarget(link) {
    var text = (link.textContent || '').trim().toLowerCase();
    var href = (link.getAttribute('href') || '').toLowerCase();

    for (var i = 0; i < scrollMap.length; i++) {
      var item = scrollMap[i];
      if (text === item.textMatch || href.indexOf(item.hrefMatch) !== -1) {
        return item;
      }
    }
    return null;
  }

  function findSection(selector) {
    var el = document.querySelector(selector);
    if (el) return el;

    // Fallback: search inside shopify section wrappers
    var sections = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].querySelector(selector)) {
        return sections[i];
      }
    }
    return null;
  }

  function scrollToSection(selector) {
    var target = findSection(selector);
    if (target) {
      // Offset for sticky header
      var headerHeight = 0;
      var header = document.querySelector('.hdt-header-sticky, header, [id*="header"]');
      if (header) headerHeight = header.offsetHeight || 0;

      var top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 10;
      window.scrollTo({ top: top, behavior: 'smooth' });
      return true;
    }
    return false;
  }

  function handleClick(e) {
    var link = e.target.closest('a');
    if (!link) return;

    var matched = getMatchedTarget(link);
    if (!matched) return;

    // Always prevent the default navigation
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (matched.redirect) {
      window.location.href = matched.redirect;
      return false;
    }

    if (isHomePage()) {
      // Already on home — just scroll
      scrollToSection(matched.selector);
    } else {
      // Not on home — go to home with a hash to trigger scroll on load
      window.location.href = '/#rg-scroll-' + matched.textMatch.replace(/\s+/g, '-');
    }

    return false;
  }

  // On page load: check if we arrived with a scroll hash
  function checkScrollHash() {
    var hash = window.location.hash;
    if (!hash || hash.indexOf('#rg-scroll-') !== 0) return;

    var key = hash.replace('#rg-scroll-', '').replace(/-/g, ' ');

    for (var i = 0; i < scrollMap.length; i++) {
      if (scrollMap[i].textMatch === key) {
        setTimeout(function () {
          scrollToSection(scrollMap[i].selector);
          // Clean the hash from the URL
          if (history.replaceState) {
            history.replaceState(null, '', window.location.pathname);
          }
        }, 800);
        break;
      }
    }
  }

  function init() {
    // Use capture phase to intercept BEFORE Shopify's own handlers
    document.addEventListener('click', handleClick, true);
    checkScrollHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
